import { ProspectStatus } from '../../../../../../../../types/api/endpoints/prospect/prospect.types';
import { FormItem } from '../../../../../../../commons/Form/Form.types';
import { DashboardProspectsFormSchema } from './UpdateStatusProspectForm.types';

export const updateStatusProspectFormData: FormItem<DashboardProspectsFormSchema>[][] = [
  [
    {
      name: 'status',
      placeholder: 'Status de la prospection...',
      label: 'Nouveau status',
      type: 'select',
      required: true,
      autoCapitalize: 'capitalize',
      options: Object.values(ProspectStatus)
        .filter((status) => Boolean(![ProspectStatus.Gagné].includes(status)))
        .map((status) => ({
          value: status,
          label: status,
        })),
    },
  ],
  [
    {
      name: 'comment',
      placeholder: 'Votre commentaire...',
      label: 'Commentaire',
      type: 'textarea',
      required: true,
      className: 'input__input--bordered',
    },
  ],
  [
    {
      name: 'reminder_date',
      type: 'hidden',
      divProps: {
        style: {
          display: 'none',
        },
      },
    },
  ],
];
